




















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapMutations } from 'vuex';

@Component({
  components: {
  },
  methods: mapMutations([
  ])
})
export default class GutHistory extends Vue {
  @Prop() private msg!: string

  get gutFatLevels(){
      return this.$store.state.gutLevels.map( obj => obj.fatty);
  }

  get gutFiberLevels(){
      return this.$store.state.gutLevels.map( obj => obj.fiber);
  }

  get gutSolidLevels(){
      return this.$store.state.gutLevels.map( obj => obj.solid);
  }

}

